<template>
	<div class="scan-verify-container">
		<!-- 顶部logo区域 -->
		<div class="header">
			<div class="logo-section">
				<img src="@/assets/images/20260303-132952.png" alt="特规通" class="logo" />
				<!-- <span class="logo-text">特规通</span> -->
			</div>
		</div>

		<!-- 中间查询信息区域 -->
		<div class="content">
			<div class="verify-card">
				<div class="verify-header">
					<i class="el-icon-success success-icon" v-if="!isException"></i>
					<i class="el-icon-error error-icon" v-if="isException"></i>
					<h3 class="verify-title">扫码验真结果</h3>
				</div>

				<div class="verify-info">
					<div v-if="!isException">
						<div class="info-item">
							<label>订单号：</label>
							<span class="info-value">{{ info.tradeNo }}</span>
						</div>
						<div class="info-item">
							<label>购买时间：</label>
							<span class="info-value">{{ info.buyTime }}</span>
						</div>
						<div class="info-item" v-if="info.tradeNo && info.tradeNo.startsWith('CO')">
							<label>企业名称：</label>
							<span class="info-value">{{ info.userId }}</span>
						</div>
						<div class="info-item" v-if="info.tradeNo && info.tradeNo.startsWith('LD')">
							<label>购买人：</label>
							<span class="info-value">{{ info.userId }}</span>
						</div>
						<div class="info-item" v-if="info.tradeNo && info.tradeNo.startsWith('LD')">
							<label>购买账号：</label>
							<span class="info-value">{{ info.userPhone }}</span>
						</div>
						<div class="info-item" v-if="info.standardCode">
							<label>标准编号：</label>
							<span class="info-value">{{ info.standardCode }}</span>
						</div>
						<div class="info-item" v-if="info.standardName">
							<label>标准名称：</label>
							<span class="info-value">{{ info.standardName }}</span>
						</div>
					</div>

					<!-- <div class="verify-result">
						<p class="result-text" v-if="!isException">您好，您查询的本商品是正品，请放心使用</p>
						<p class="result-text" v-else>您好，未查询到具体订单信息</p>
					</div> -->

					<div class="query-verify-result">
						<div v-if="!isException">
							<!-- <el-alert title="成功提示的文案" type="success" show-icon> </el-alert> -->
							<p class="result-text">
								<i class="el-icon-warning success-icon"></i>
								以上法规、标准、图书由北京品读文化发展有限公司委托特规通平台销售的正版出版物电子版。仅限用户个人使用，未经授权严禁复制传播及用于其他商业用途。若发现侵权行为，请致电：18911620150。感谢您与我们共同维护版权生态。
							</p>
							<p style="margin-top: 1em">欢迎访问特规通（<a href="https://www.teguitong.com" target="_blank">www.teguitong.com</a>）查看更多正版资源</p>
						</div>
						<p class="result-text" v-else>您好，未查询到具体订单信息</p>
					</div>
				</div>

				<div class="verify-tip">
					<!-- <div class="tip-item">
						<i class="el-icon-info"></i>
						<span>此验证结果仅代表当前查询时刻的状态</span>
					</div> -->
					<!-- <div class="tip-item">
						<i class="el-icon-warning warning-icon"></i>
						<span>如发现异常，请联系客服处理</span>
					</div> -->
				</div>
			</div>
		</div>

		<!-- 底部版权信息 -->
		<div class="footer">
			<div class="footer-content" @click="handleClick">
				<p class="copyright">©2025 量大（北京）信息科技研究院有限公司</p>
				<p class="icp">京ICP备2024096922号-3</p>
			</div>
		</div>
	</div>
</template>

<script>
	import { getConsumerOrderVerifyAuth } from '@/api/order/order';
	export default {
		name: 'ScanVerify',
		data() {
			return {
				info: {
					standardName: '压力容器 第2部分：材料',
					standardCode: 'GB/T 150.2-2024',
					orderId: '202503031329520001',
					orderDate: '2025-03-03 13:29:52'
				},

				//是否异常
				isException: false
			};
		},
		created() {
			// 这里可以添加获取URL参数或从路由获取查询信息的逻辑
			// this.getQueryInfo();
			// this.getConsumerOrderInfo();
			this.getConsumerOrderVerifyAuth();
		},
		methods: {
			// getQueryInfo() {
			// 从URL参数或路由中获取查询信息
			// const query = this.$route.query;
			// if (query.standardName) {
			//     this.standardName = query.standardName;
			// }
			// if (query.standardCode) {
			//     this.standardCode = query.standardCode;
			// }
			// },

			getConsumerOrderVerifyAuth() {
				const path = this.$route.path;
				// console.log('path', path);
				//如果没有path参数，直接返回
				if (!path) {
					// console.error('路径参数为空');
					this.isException = true;
					return;
				}

				// 获取路径中最后两个斜杠分割的参数
				const pathSegments = path.split('/').filter(segment => segment.trim() !== '');

				if (pathSegments.length >= 2) {
					// 获取最后两个参数
					const fileName = pathSegments[pathSegments.length - 1];
					const tradeNo = pathSegments[pathSegments.length - 2];

					// console.log('fileName:', fileName, 'tradeNo:', tradeNo);

					const params = {
						tradeNo,
						fileName
					};

					getConsumerOrderVerifyAuth(params)
						.then(res => {
							if (res.code === 200) {
								this.info = res.data;
								this.isException = false;
							} else {
								this.isException = true;
							}
						})
						.catch(error => {
							console.error('API调用失败:', error);
							this.isException = true;
						});
				} else {
					console.error('路径参数不足，需要至少2个参数');
					this.isException = true;
				}
			},

			handleClick() {
				window.open('https://beian.miit.gov.cn/#/home');
			}
		}
	};
</script>

<style lang="less" scoped>
	.success-icon {
		font-size: 2em;
		color: #67c23a;
		margin-right: 0.1em;
	}

	.warning-icon {
		font-size: 4em;
		color: #e6a23c;
		margin-right: 0.5em;
	}

	.scan-verify-container {
		min-height: 100vh;
		display: flex;
		flex-direction: column;
		background: #fff;
		font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
		font-size: 16px;
	}

	// 顶部logo区域
	.header {
		padding: 1em;
		background: rgba(255, 255, 255, 0.95);
		backdrop-filter: blur(10px);
		box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);

		.logo-section {
			display: flex;
			align-items: center;
			// justify-content: center;

			.logo {
				// width: 2em;
				// height: 2em;
				height: 8em;
				// margin-right: 12px;
			}

			.logo-text {
				font-size: 2em;
				font-weight: 600;
				color: #303133;
				background: linear-gradient(135deg, #667eea, #764ba2);
				-webkit-background-clip: text;
				-webkit-text-fill-color: transparent;
				background-clip: text;
			}
		}
	}

	// 中间内容区域
	.content {
		flex: 1;
		display: flex;
		// align-items: center;
		justify-content: center;
		padding: 2em;
		// font-size: 6em;

		.verify-card {
			background: rgba(255, 255, 255, 0.95);
			backdrop-filter: blur(15px);
			// border-radius: 20px;
			padding: 30px;
			// box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
			// max-width: 400px;
			width: 80%;
			text-align: center;
			margin: 4em auto 0;

			.verify-header {
				margin-bottom: 6em;

				.success-icon {
					font-size: 9em;
					color: #67c23a;
					margin-bottom: 0.2em;
					display: block;
				}

				.error-icon {
					font-size: 9em;
					color: #f56c6c;
					margin-bottom: 0.2em;
					display: block;
				}

				.verify-title {
					font-size: 3.6em;
					font-weight: 600;
					color: #303133;
					margin: 0;
				}
			}

			.verify-info {
				margin-bottom: 3em;

				.info-item {
					margin-bottom: 2em;
					text-align: left;

					label {
						// font-weight: 600;
						color: #606266;
						font-size: 2.6em;
						display: inline-block;
						// width: 80px;
					}

					.info-value {
						color: #303133;
						font-size: 2.6em;
						font-weight: 500;
					}
				}

				.query-verify-result {
					margin-top: 4em;
					border-top: 1px solid #e4e7ed;
					padding-top: 1em;
					p {
						font-size: 2.8em;
						color: #303133;
						margin: 0;
						text-align: left;
						line-height: 1.8em;
					}
				}

				.verify-result {
					background: linear-gradient(135deg, #f0f9ff, #e6f7ff);
					border-radius: 12px;
					border-left: 4px solid #409eff;
					padding: 2.2em;
					margin-top: 5em;

					.result-text {
						color: #409eff;
						font-size: 2.4em;
						font-weight: 500;
						margin: 0;
						line-height: 1.5;
						text-align: left;
					}
				}
			}

			.verify-tip {
				// border-top: 1px solid #ebeef5;
				// padding-top: 20px;
				// padding-top: 3em;

				.tip-item {
					display: flex;
					align-items: center;
					margin-bottom: 10px;
					font-size: 2.3em;
					color: #909399;

					&:last-child {
						margin-bottom: 0;
					}

					i {
						margin-right: 8px;
						font-size: 14px;
					}

					&:first-child i {
						color: #409eff;
					}

					&:last-child i {
						color: #e6a23c;
					}
				}
			}
		}
	}

	// 底部版权区域
	.footer {
		background: rgba(0, 0, 0, 0.8);
		padding: 4em;
		color: white;

		.footer-content {
			text-align: center;

			.copyright {
				font-size: 2.3em;
				margin: 0 0 8px 0;
				opacity: 0.8;
			}

			.icp {
				font-size: 2.3em;
				margin: 0;
				opacity: 0.6;
			}
		}
	}

	// 响应式设计
	@media (max-width: 480px) {
		.header {
			padding: 15px 12px;

			.logo-section {
				.logo {
					width: 32px;
					height: 32px;
				}

				.logo-text {
					font-size: 20px;
				}
			}
		}

		.content {
			padding: 15px 12px;

			.verify-card {
				padding: 20px;

				.verify-header {
					.success-icon {
						font-size: 48px;
					}

					.verify-title {
						font-size: 20px;
					}
				}

				.verify-info {
					.info-item {
						label {
							width: 70px;
							font-size: 13px;
						}

						.info-value {
							font-size: 14px;
						}
					}

					.verify-result {
						.result-text {
							font-size: 14px;
						}
					}
				}
			}
		}
	}

	// 动画效果
	.verify-card {
		animation: slideInUp 0.6s ease-out;
	}

	@keyframes slideInUp {
		from {
			transform: translateY(30px);
			opacity: 0;
		}
		to {
			transform: translateY(0);
			opacity: 1;
		}
	}

	// 悬停效果
	.verify-card:hover {
		transform: translateY(-5px);
		transition: transform 0.3s ease;
	}
</style>
